import React from 'react'
import { connect } from 'react-redux'
import OrderActions from '../../Redux/OrderRedux'
import { includes, isObject } from 'lodash'
import { currentRole, currentBranch } from '../../Utils/PrivilegeUtils'
import DateTime from 'react-datetime'

class DownloadOrderDetailList extends React.Component {
  constructor (props) {
    super(props)
    this.dateFormat = 'DD MMM YYYY'
    this.orderStatus = [
      { value: '', label: 'ALL' },
      { value: 'checkout', label: 'CHECKOUT' },
      { value: 'payment-pending', label: 'PENDING' },
      { value: 'payment-failed', label: 'FAILED' },
      { value: 'canceled', label: 'CANCELED' },
      { value: 'confirmed', label: 'CONFIRMED' },
      { value: 'expired', label: 'EXPIRED' }
    ]

    this.productType = [
      { value: '', label: 'ALL' },
      { value: 'modems', label: 'MODEM' },
      { value: 'attractions', label: 'ATTRACTION' },
      { value: 'events', label: 'EVENT', restriction: ['PH'] },
      { value: 'insurances', label: 'INSURANCE', restriction: ['PH'] },
      { value: 'inventories', label: 'E-COMMERCE' },
      { value: 'esims', label: 'ESIM' },
    ].filter((option) => { return (!includes(option.restriction, currentBranch()) && !includes(option.restriction, currentRole())) })

    this.sourceSelector = [
      { value: 'ID', label: 'Passpod' },
      { value: 'AP', label: 'Travypass' }
    ]

    this.state = {
      filter: {
        created_from: null,
        created_until: null,
        code: '',
        status: '',
        type: ''
      }
    }
  }

  componentDidMount = () => {
    if (currentRole() === 'admin_travy') {
      this.setState({ filter: { code: 'AP' } })
    }
  }

  _filterChange = (data, field) => {
    const uniq = ['page', 'filterDate', 'created_from', 'created_until']
    let val = null
    if (includes(uniq, field)) {
      if (field === 'created_from' || field === 'created_until') {
        if (isObject(data)) {
          val = data
        }
      } else {
        val = data
      }
    } else {
      val = data.target.value
    }
    let filter = { ...this.state.filter }
    filter[field] = val
    this.setState({ filter, apply: false })
  }

  _submit = (event) => {
    event.preventDefault()
    let data = {
      ...this.state.filter
    }

    if (this.state.filter.created_from && this.state.filter.created_until) {
      data.created_from = this.state.filter.created_from.format('Y-MM-DD')
      data.created_until = this.state.filter.created_until.format('Y-MM-DD')
    } else {
      data.created_from = null
      data.created_until = null
    }

    this.props.download(data)

    this.props.closeModal()
  }

  render () {
    const { order } = this.props
    const { created_from } = this.state.filter
    let yesterday = created_from
    return (
      <form onSubmit={(event) => this._submit(event)} className='section' style={{ width: '25vw' }}>
        <header className='title-block'>
          <h4 className='title mr-auto'>
            Download Order Detail List
            {(order.fetching || order.processing) &&
              <div className='badge badge-info ml-2'>{order.fetching ? 'Loading' : 'Processing'} ...</div>
            }
          </h4>
        </header>
        <div className='form-group'>
          <label className='control-label mr-2'>Date From</label>
          <DateTime
            value={this.state.filter.created_from}
            closeOnSelect
            onChange={(date) => this._filterChange(date, 'created_from')}
            dateFormat='DD/MM/YYYY'
            timeFormat={false}
          />
        </div>
        <div className='form-group'>
          <label className='control-label mr-2'>Date To</label>
          <DateTime
            value={this.state.filter.created_until}
            closeOnSelect
            onChange={(date) => this._filterChange(date, 'created_until')}
            dateFormat='DD/MM/YYYY'
            timeFormat={false}
            isValidDate={(current) => current.isAfter(yesterday)}
          />
        </div>
        {
          currentBranch() !== 'PH' &&
          currentRole() !== 'admin_travy' &&
          <div className='form-group mr-2 mb-3'>
            <label className='control-label mr-2'>Source</label>
            <select className='form-control' value={this.state.filter.code} onChange={(event) => this._filterChange(event, 'code')} required>
              <option value='' disabled>Select Source</option>
              {
                this.sourceSelector.map((list, i) => (
                  <option key={i} value={list.value}>{list.label}</option>
                ))
              }
            </select>
          </div>
        }
        <div className='form-group mr-2 mb-3'>
          <label className='control-label mr-2'>Status</label>
          <select className='form-control' value={this.state.filter.status} onChange={(event) => this._filterChange(event, 'status')}>
            {
              this.orderStatus.map((list, i) => (
                <option key={i} value={list.value}>{list.label}</option>
              ))
            }
          </select>
        </div>
        <div className='form-group mr-2 mb-3'>
          <label className='control-label mr-2'>Product Type</label>
          <select className='form-control' value={this.state.filter.type} onChange={(event) => this._filterChange(event, 'type')}>
            {
              this.productType.map((list, i) => (
                <option key={i} value={list.value}>{list.label}</option>
              ))
            }
          </select>
        </div>

        <div className='text-right'>
          <button type='button' className='btn btn-lg btn-secondary mr-2' onClick={() => this.props.closeModal()}>Close</button>
          <button type='submit' className='btn btn-lg btn-primary'>Download</button>
        </div>
      </form>
    )
  }
}

const stateToProps = (state) => ({
  order: state.order,
  auth: state.auth
})

const dispatchToProps = (dispatch) => ({
  download: filter => dispatch(OrderActions.orderDetailListDownloadRequest(filter))
})

export default connect(stateToProps, dispatchToProps)(DownloadOrderDetailList)



// WEBPACK FOOTER //
// ./src/Containers/Order/DownloadOrderDetailList.js